import { compose } from 'recompose';
import apiInterceptor from '../../../api/interceptor';
import SalesInvoiceReport from './SalesInvoiceReport';
import { salesReportApi } from '../../common/base.api';

const composedSalesInvoiceReport = compose(apiInterceptor({ ...salesReportApi }))(SalesInvoiceReport);

export default composedSalesInvoiceReport;
